var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.finished
    ? _c(
        "w-card",
        { attrs: { "max-width": "900" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("newStock")))]),
          _c(
            "w-card-content",
            { style: { flexGrow: 0 } },
            [
              _vm.productHasSizes
                ? _c("app-stock-edit-size-rows", {
                    attrs: { value: _vm.stock },
                    on: {
                      input: function ($event) {
                        _vm.sizeStocks = $event
                      },
                    },
                  })
                : _c("app-edit-row", {
                    attrs: { value: _vm.stock, single: true },
                    on: {
                      updateStock: function ($event) {
                        return _vm.onUpdateStock($event)
                      },
                    },
                  }),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel mr",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "save", disabled: !_vm.valid },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }